import React, { useState } from "react";

const API = process.env.REACT_APP_API_URL || "";

async function login(mail, password) {
  const res = await fetch(`${API}/api/login`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ mail, password }),
  });

  const data = await res.json();
  if (!res.ok) {
    if (data.error === "invalid_credentials") throw new Error("Identifiants invalides");
    if (data.error === "account_not_allowed") throw new Error(data.message);
    throw new Error("Erreur de connexion");
  }
  return data;
}

function ssoErrorMessage() {
  const param = new URLSearchParams(window.location.search).get("sso_error");
  if (!param) return null;
  return param === "not_configured" ? "La connexion SSO n'est pas encore configurée." : param;
}

export default function LoginPage() {
  const [mail, setMail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(ssoErrorMessage);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const data = await login(mail, password);
      window.location.href = data.mustChangePassword ? "/changer-mot-de-passe" : "/";
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-page" style={{ maxWidth: 400, margin: "60px auto" }}>
      <h2 style={{ marginBottom: 24 }}>Connexion</h2>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            type="text"
            className="form-control"
            value={mail}
            onChange={(e) => setMail(e.target.value)}
            autoComplete="username"
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Mot de passe</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>

        {error && (
          <div style={{ marginBottom: 16, padding: "8px 14px", borderRadius: 6, background: "#fee2e2", color: "#991b1b" }}>
            {error}
          </div>
        )}

        <button type="submit" className="fr-btn" disabled={loading} style={{ width: "100%" }}>
          {loading ? "Connexion..." : "Se connecter"}
        </button>
      </form>

      <div style={{ margin: "16px 0", textAlign: "center", color: "#6b7280" }}>ou</div>

      <a href={`${API}/sso/login`} className="fr-btn--secondary" style={{ display: "block", textAlign: "center", width: "100%" }}>
        Se connecter via SSO
      </a>
    </div>
  );
}
